import React from 'react'

const Mobile = ({isDarkMode}) => {
    const bodyClass = `skills__content ${isDarkMode ? 'dark-mode': ''}`

    return (
        <div className={bodyClass}>
            <h3 className="skills__title">Mobile Development</h3>

            <div className="skills__box">
                <div className="skills__group">

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">Flutter</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name"> React Native</h3>
                            <span className="skills__level">Basic</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">Swift</h3>
                            <span className="skills__level">Basic</span>
                        </div>
                    </div>
                </div>

                <div className="skills__group">

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">Java</h3>
                            <span className="skills__level">Basic</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name"> Kotlin</h3>
                            <span className="skills__level">Basic</span>
                        </div>
                    </div>

                    <div className="skills__data">
                        <i className="uil uil-check-circle"></i>

                        <div>
                            <h3 className="skills__name">Objective C</h3>
                            <span className="skills__level">Basic</span>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default Mobile
